export default [{
  path: '/gdwxxfindex',
  name: 'gdwxindex',
  component: () => import('@/pages/GDWXXFcallfee/blank')
},
{
  path: '/gdwxxfcallfee',
  name: 'gdwxxfcallfee',
  meta: {
    title: '粉丝回馈赢好礼'
  },
  component: () => import('@/pages/GDWXXFcallfee/Index')
},
{
  path: '/gdwxxflogin',
  name: 'gdwxxflogin',
  meta: {
    title: '注册'
  },
  component: () => import('@/pages/GDWXXFcallfee/Register')
},
{
  path: '/gdwxxfqrcode',
  name: 'gdwxxfqrcode',
  meta: {
    title: '关注中国银行广东省分行'
  },
  component: () => import('@/pages/GDWXXFcallfee/Qrcode')
},
{
  path: '/gdwxxfrecharge',
  name: 'gdwxxfrecharge',
  meta: {
    title: '充值'
  },
  component: () => import('@/pages/GDWXXFcallfee/recharge')
},
{
  path: '/gdwxxfaddress',
  name: 'gdwxxfaddress',
  meta: {
    title: '填写收货地址'
  },
  component: () => import('@/pages/GDWXXFcallfee/RegisterAddress')
}
]



// WEBPACK FOOTER //
// ./src/router/GDWXXFindex.js